import React from "react";
import _ from "lodash";
import { DEMAND_SOURCE_TYPE } from "constants/DemandSources";
import { getDemandSourceType } from "components/network/pricing-rules/DataHelpers";

export default function DemandSourceView({ data, demandSource = {} }) {
  const dsType = getDemandSourceType(data);
  if (_.isNil(dsType) || dsType === DEMAND_SOURCE_TYPE.ALL) {
    return <div className="text-sm">-</div>;
  }

  return (
    <div className="flex flex-wrap gap-x-2 gap-y-1 text-sm">
      {_.keys(data).map((key) => {
        const dsInfo = _.find(demandSource, { demandSource: key }) || {};
        const bidders = _.get(dsInfo, "bidders", []);
        return (
          <div key={key} className="bg-blue-100 px-1">
            {_.startCase(key)}
            {data[key].all === true ? "" : `(${data[key].ids.length})`}
            {": "}
            <span className="text-gray-800">
              {data[key].all === true
                ? "All"
                : `${data[key].ids
                    .map((id) => {
                      const item = _.find(bidders, { id: id }) || {};
                      return `[${id}]${
                        !_.isNil(item.name) ? ` ${item.name}` : ""
                      }`;
                    })
                    .join(", ")}`}
            </span>
          </div>
        );
      })}
    </div>
  );
}
